/** Textes « alertes » — le français fait foi. */
export const alertes = {
};
